export const CUSTOMER_SERVICE_URL = 'https://support.flosports.tv/'
